import React from 'react';
import { getClonedChild } from '@landr/maestro';
import * as Styled from './styled';
import { ColumnRatio, ColumnDirection, ColoredColumn } from './types';

const Info: React.FC = ({ children }) => {
    return <>{children}</>;
};

Info.displayName = 'TwoColumns.Info';

const Media: React.FC = ({ children }) => {
    return <>{children}</>;
};

Media.displayName = 'TwoColumns.Media';

interface TwoColumnsSubComponents {
    Info: typeof Info;
    Media: typeof Media;
}

export const TwoColumns: React.FC<{
    direction: ColumnDirection;
    columnRatio: ColumnRatio;
    coloredColumn?: ColoredColumn;
}> &
    TwoColumnsSubComponents = ({
    direction,
    columnRatio,
    coloredColumn = 'info',
    children,
}) => {
    const childrenArray = React.Children.toArray(children);

    const info = getClonedChild(childrenArray, 'TwoColumns.Info', {
        key: 'info',
    });
    const media = getClonedChild(childrenArray, 'TwoColumns.Media', {
        key: 'media',
    });

    return (
        <Styled.Container
            flexDirection={direction}
            justifyContent="space-between"
        >
            <Styled.Info
                flexDirection="column"
                columnRatio={columnRatio}
                direction={direction}
                isColored={coloredColumn === 'info'}
            >
                {info}
            </Styled.Info>
            <Styled.Media
                columnRatio={columnRatio}
                isColored={coloredColumn === 'media'}
            >
                {media}
            </Styled.Media>
        </Styled.Container>
    );
};

TwoColumns.Info = Info;
TwoColumns.Media = Media;
